<template>
  <el-aside width="200px" style="overflow: hidden;" :style="{ 'background-color': sideTheme }">
    <div
      style="display:flex; justify-content: center;align-items: center;"
      :style="{ 'background-color': logoTheme }"
    >
      <div>
        <img height="30" style="vertical-align: bottom;margin-right:6px;" src="@/assets/log.png" />
      </div>
      <div v-if="menuShow">
        <h1 class="text-white">家园中心</h1>
      </div>
    </div>
    <el-scrollbar
      wrap-style="overflow-x:hidden;"
      style="height: calc(100% - 60px)"
    >
      <el-menu
        unique-opened
        :router="true"
        :collapse="!menuShow"
        class="el-menu-vertical border-0"
        :background-color="sideTheme"
        text-color="#fff"
        mode="vertical"
        :collapse-transition="false"
        :default-active="activePath"
      >
        <template v-for="item in sidebarRouters">
          <template v-if="!item.hidden">
            <template
              v-if="
                item.children &&
                item.children.length > 0 &&
                item.meta.menuType === 1
              "
            >
              <el-submenu :index="item.path" :key="item.path">
                <template slot="title">
                  <i v-if="item.meta.icon" :class="item.meta.icon"></i>
                  <span slot="title">{{ item.meta.title }}</span>
                </template>
                <template v-for="it in item.children">
                  <!--                  <template v-if="it.meta.menuType===2">-->
                  <!--                    <el-menu-item v-if="!it.hidden" :index="resolvePath(item.path,it.path)" :key="it.path">-->
                  <!--                      <i v-if="it.meta.icon" :class="it.meta.icon"></i>-->
                  <!--                      <span slot="title">{{it.meta.title }}</span>-->
                  <!--                    </el-menu-item>-->
                  <!--                  </template>-->

                  <template
                    v-if="
                      it.children &&
                      it.children.length > 0 &&
                      it.meta.menuType === 1
                    "
                  >
                    <el-submenu :index="it.path" :key="it.path">
                      <template slot="title">
                        <i v-if="it.meta.icon" :class="it.meta.icon"></i>
                        <span slot="title">{{ it.meta.title }}</span>
                      </template>
                      <template v-for="itt in it.children">
                        <el-menu-item
                          v-if="!itt.hidden"
                          :index="
                            resolvePath(item.path + '\/' + it.path, itt.path)
                          "
                          :key="itt.path"
                        >
                          <i v-if="itt.meta.icon" :class="it.meta.icon"></i>
                          <span slot="title">{{ itt.meta.title }}</span>
                        </el-menu-item>
                      </template>
                    </el-submenu>
                  </template>
                  <template v-if="it.meta.menuType === 2">
                    <el-menu-item
                      v-if="!it.hidden"
                      :index="resolvePath(item.path, it.path)"
                      :key="it.path"
                    >
                      <i v-if="it.meta.icon" :class="it.meta.icon"></i>
                      <span slot="title">{{ it.meta.title }}</span>
                    </el-menu-item>
                  </template>
                </template>
              </el-submenu>
            </template>
            <template
              v-if="
                item.children &&
                item.children.length > 0 &&
                item.meta.menuType === 2
              "
            >
              <el-menu-item
                v-if="!item.hidden"
                :index="item.children[0].path"
                :key="item.children[0].path"
              >
                <i
                  v-if="item.children[0].meta.icon"
                  :class="item.children[0].meta.icon"
                ></i>
                <span slot="title">{{ item.children[0].meta.title }}</span>
              </el-menu-item>
            </template>
          </template>
        </template>
      </el-menu>
    </el-scrollbar>
  </el-aside>
</template>

<script>
import { routeArr } from "@/router";
import { mapGetters } from "vuex";
import path from "path";

export default {
  name: "NavBar",
  data() {
    return {
      routeArr: routeArr,
      activePath: undefined,
    };
  },
  components: {},
  props: {
    menuShow: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      "theme",
      "sideTheme",
      "logoTheme",
      "headerTheme",
      "sidebarRouters",
    ]),
  },
  watch: {
    $route() {
      this.routeChange();
    },
  },
  methods: {
    routeChange() {
      const route = this.$route;
      if (route) {
        this.activePath = route.fullPath;
      }
    },
    isExternal(path) {
      return /^(https?:|mailto:|tel:)/.test(path);
    },
    resolvePath(fPath, cPath) {
      if (this.isExternal(cPath)) {
        return cPath;
      }
      if (this.isExternal(fPath)) {
        return this.fPath;
      }
      return path.resolve(fPath, cPath);
    },
  },
};
</script>

<style lang='scss' scoped>
.el-menu-vertical:not(.el-menu--collapse) {
  width: 200px;
}
</style>
